import CharlesButton from "components/base/Button";
import Page from "components/base/Page";
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { v4 } from "uuid";
import { ProductContext } from "./context";

const Products = () => {
  const { products, setProducts } = useContext(ProductContext);

  console.log("products, setProducts", products, setProducts);

  const navigate = useNavigate();

  function createProduct() {
    const name = window.prompt("Enter product name:");
    if (!name) {
      return;
    }

    const product = {
      id: v4(),
      name,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      version: "1.0",
    };
    setProducts((prevProducts) => [...prevProducts, product]);
    navigate(`${product.id}`);
  }

  return (
    <Page
      title="Product Release"
      rightButtons={
        <div>
          <CharlesButton onClick={createProduct}>+ New Product</CharlesButton>
        </div>
      }
    >
      <div className="m-6 text-sm">
        <div className="">
          <table>
            <tbody>
              {products.map((i) => (
                <tr key={i.id} className="border-y ">
                  <td>
                    <Link to={`${i.id}`}>{i.name}</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Page>
  );
};

export default Products;
